import { css } from "styled-components";
import { DEFAULT_SQUARE_WIDTH, DEFAULT_SQUARE_HEIGHT } from "./Squares";
import { DEFAULT_VERTICAL_RECTANGLE_WIDTH } from "./Vertical Rectangles";
import { DEFAULT_HORIZONTAL_RECTANGLE_WIDTH } from "./Horizontal Rectangles";

export function getColor(variantColor) {
  switch (variantColor) {
    case 1:
      return {
        primary: "#0a0a0b",
        secondary: "#f4f4f4",
        tertiary: "#f4f4f4",
        quaternary: "#f4f4f4",
        fillOpacity: "0.04",
        textColor: "#FFFFFF",
        callTextColor: "#444444",
        curvedLine: "#f4f4f4",
        curvedLineOpacity: "0.051",
        triangleOpacity: "0.1",
      };
    case 2:
      return {
        primary: "#0a0a0b",
        secondary: "#F1A12E",
        tertiary: "#444444",
        quaternary: "#7B7C85",
        fillOpacity: "0.2",
        textColor: "#FFFFFF",
        callTextColor: "#FFFFFF",
        curvedLine: "#4A4B54",
        curvedLineOpacity: "0.051",
        triangleOpacity: "0.1",
      };
    default:
    case 3:
      return {
        primary: "#FAFAFA",
        secondary: "#2D6FBA",
        tertiary: "#444444",
        quaternary: "#7B7C85",
        fillOpacity: "0.1",
        textColor: "#444444",
        callTextColor: "#FFFFFF",
        curvedLine: "#11a7d9",
        curvedLineOpacity: "0.02",
        triangleOpacity: "1",
      };
    case 4:
      return {
        primary: "#FAFAFA",
        secondary: "#A22120",
        tertiary: "#444444",
        quaternary: "#7B7C85",
        fillOpacity: "0.1",
        textColor: "#444444",
        callTextColor: "#FFFFFF",
        curvedLine: "#4A4B54",
        curvedLineOpacity: "0.051",
        triangleOpacity: "1",
      };
    case 5:
      return {
        primary: "#FAFAFA",
        secondary: "#51B374",
        tertiary: "#444444",
        quaternary: "#7B7C85",
        fillOpacity: "0.1",
        textColor: "#444444",
        callTextColor: "#FFFFFF",
        curvedLine: "#4A4B54",
        curvedLineOpacity: "0.051",
        triangleOpacity: "1",
      };
  }
}

export const style = {
  transition: "fill 0.5s ease-in-out, stroke 0.5s ease-in-out",
};

export function convertPositionRatio({
  positions,
  currentSize,
  draggableSize,
}) {
  const ratio = currentSize / draggableSize;
  return {
    x: positions.x * ratio,
    y: positions.y * ratio,
  };
}

// SQUARES

const squarePositions = {
  square01: {
    imagePosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      x: -474 / (DEFAULT_SQUARE_WIDTH / size),
      y: 137 / (DEFAULT_SQUARE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      x: 936.21 / (DEFAULT_SQUARE_WIDTH / size),
      y: 24.25 / (DEFAULT_SQUARE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      x: 544 / (DEFAULT_SQUARE_WIDTH / size),
      y: 600 / (DEFAULT_SQUARE_WIDTH / size),
    }),
  },
  square02: {
    imagePosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      x: 419 / (DEFAULT_SQUARE_WIDTH / size),
      y: 286 / (DEFAULT_SQUARE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      x: 936.21 / (DEFAULT_SQUARE_WIDTH / size),
      y: 24.25 / (DEFAULT_SQUARE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      y: 610 / (DEFAULT_SQUARE_WIDTH / size),
      x: 40 / (DEFAULT_SQUARE_WIDTH / size),
    }),
  },
  square03: {
    imagePosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      x: 339 / (DEFAULT_SQUARE_WIDTH / size),
      y: 376 / (DEFAULT_SQUARE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      x: 936.21 / (DEFAULT_SQUARE_WIDTH / size),
      y: 24.25 / (DEFAULT_SQUARE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      y: 610 / (DEFAULT_SQUARE_WIDTH / size),
      x: 40 / (DEFAULT_SQUARE_WIDTH / size),
    }),
  },
  square04: {
    imagePosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      x: 272 / (DEFAULT_SQUARE_WIDTH / size),
      y: -147 / (DEFAULT_SQUARE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      x: 936.21 / (DEFAULT_SQUARE_WIDTH / size),
      y: 1180 / (DEFAULT_SQUARE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      y: 860 / (DEFAULT_SQUARE_WIDTH / size),
      x: 63 / (DEFAULT_SQUARE_WIDTH / size),
    }),
  },
  square05: {
    imagePosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      x: 448 / (DEFAULT_SQUARE_WIDTH / size),
      y: 123 / (DEFAULT_SQUARE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      x: 23.5 / (DEFAULT_SQUARE_WIDTH / size),
      y: 24.25 / (DEFAULT_SQUARE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      y: 550 / (DEFAULT_SQUARE_WIDTH / size),
      x: 24 / (DEFAULT_SQUARE_WIDTH / size),
    }),
  },
  square06: {
    imagePosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      x: -277 / (DEFAULT_SQUARE_WIDTH / size),
      y: -78 / (DEFAULT_SQUARE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      x: 936.21 / (DEFAULT_SQUARE_WIDTH / size),
      y: 24.25 / (DEFAULT_SQUARE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      y: 720 / (DEFAULT_SQUARE_WIDTH / size),
      x: 500 / (DEFAULT_SQUARE_WIDTH / size),
    }),
  },
  square07: {
    imagePosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      x: 432 / (DEFAULT_SQUARE_WIDTH / size),
      y: -19 / (DEFAULT_SQUARE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      x: 24.25 / (DEFAULT_SQUARE_WIDTH / size),
      y: 24.25 / (DEFAULT_SQUARE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      y: 600 / (DEFAULT_SQUARE_WIDTH / size),
      x: 45 / (DEFAULT_SQUARE_WIDTH / size),
    }),
  },
  square08: {
    imagePosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      x: 317 / (DEFAULT_SQUARE_WIDTH / size),
      y: 19 / (DEFAULT_SQUARE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      x: 24.25 / (DEFAULT_SQUARE_WIDTH / size),
      y: 24.25 / (DEFAULT_SQUARE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      y: 600 / (DEFAULT_SQUARE_WIDTH / size),
      x: 65 / (DEFAULT_SQUARE_WIDTH / size),
    }),
  },
  square09: {
    imagePosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      x: 340 / (DEFAULT_SQUARE_WIDTH / size),
      y: 0.1 / (DEFAULT_SQUARE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      x: 24.25 / (DEFAULT_SQUARE_WIDTH / size),
      y: 148 / (DEFAULT_SQUARE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      y: 600 / (DEFAULT_SQUARE_WIDTH / size),
      x: 24 / (DEFAULT_SQUARE_WIDTH / size),
    }),
  },
  square10: {
    imagePosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      x: 315 / (DEFAULT_SQUARE_WIDTH / size),
      y: 0.1 / (DEFAULT_SQUARE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      x: 24.25 / (DEFAULT_SQUARE_WIDTH / size),
      y: 24.25 / (DEFAULT_SQUARE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      y: 600 / (DEFAULT_SQUARE_WIDTH / size),
      x: 65 / (DEFAULT_SQUARE_WIDTH / size),
    }),
  },
};

export function pickSquareDefaultPositions({ shape, size }) {
  switch (shape) {
    case 1:
    default:
      return {
        imagePosition: squarePositions.square01.imagePosition({ size }),
        logoPosition: squarePositions.square01.logoPosition({ size }),
        labelsPosition: squarePositions.square01.labelsPosition({ size }),
      };
    case 2:
      return {
        imagePosition: squarePositions.square02.imagePosition({ size }),
        logoPosition: squarePositions.square02.logoPosition({ size }),
        labelsPosition: squarePositions.square02.labelsPosition({ size }),
      };
    case 3:
      return {
        imagePosition: squarePositions.square03.imagePosition({ size }),
        logoPosition: squarePositions.square03.logoPosition({ size }),
        labelsPosition: squarePositions.square03.labelsPosition({ size }),
      };
    case 4:
      return {
        imagePosition: squarePositions.square04.imagePosition({ size }),
        logoPosition: squarePositions.square04.logoPosition({ size }),
        labelsPosition: squarePositions.square04.labelsPosition({ size }),
      };
    case 5:
      return {
        imagePosition: squarePositions.square05.imagePosition({ size }),
        logoPosition: squarePositions.square05.logoPosition({ size }),
        labelsPosition: squarePositions.square05.labelsPosition({ size }),
      };
    case 6:
      return {
        imagePosition: squarePositions.square06.imagePosition({ size }),
        logoPosition: squarePositions.square06.logoPosition({ size }),
        labelsPosition: squarePositions.square06.labelsPosition({ size }),
      };
    case 7:
      return {
        imagePosition: squarePositions.square07.imagePosition({ size }),
        logoPosition: squarePositions.square07.logoPosition({ size }),
        labelsPosition: squarePositions.square07.labelsPosition({ size }),
      };
    case 8:
      return {
        imagePosition: squarePositions.square08.imagePosition({ size }),
        logoPosition: squarePositions.square08.logoPosition({ size }),
        labelsPosition: squarePositions.square08.labelsPosition({ size }),
      };
    case 9:
      return {
        imagePosition: squarePositions.square09.imagePosition({ size }),
        logoPosition: squarePositions.square09.logoPosition({ size }),
        labelsPosition: squarePositions.square09.labelsPosition({ size }),
      };
    case 10:
      return {
        imagePosition: squarePositions.square10.imagePosition({ size }),
        logoPosition: squarePositions.square10.logoPosition({ size }),
        labelsPosition: squarePositions.square10.labelsPosition({ size }),
      };
  }
}

const squareSizes = {
  square01: {
    imageSize: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      width: 1016 / (DEFAULT_SQUARE_WIDTH / size),
      height: 1270 / (DEFAULT_SQUARE_WIDTH / size),
    }),
  },

  square02: {
    imageSize: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      width: 859 / (DEFAULT_SQUARE_WIDTH / size),
      height: 1073.75 / (DEFAULT_SQUARE_WIDTH / size),
    }),
  },

  square03: {
    imageSize: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      width: 859 / (DEFAULT_SQUARE_WIDTH / size),
      height: 1073.75 / (DEFAULT_SQUARE_WIDTH / size),
    }),
  },
  square04: {
    imageSize: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      width: 1000 / (DEFAULT_SQUARE_WIDTH / size),
      height: 1250 / (DEFAULT_SQUARE_WIDTH / size),
    }),
  },

  square05: {
    imageSize: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      width: 1000 / (DEFAULT_SQUARE_WIDTH / size),
      height: 1250 / (DEFAULT_SQUARE_WIDTH / size),
    }),
  },

  square06: {
    imageSize: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      width: 1115 / (DEFAULT_SQUARE_WIDTH / size),
      height: 1393.75 / (DEFAULT_SQUARE_WIDTH / size),
    }),
  },

  square07: {
    imageSize: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      width: 1042 / (DEFAULT_SQUARE_WIDTH / size),
      height: 1302.5 / (DEFAULT_SQUARE_WIDTH / size),
    }),
  },

  square08: {
    imageSize: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      width: 1157 / (DEFAULT_SQUARE_WIDTH / size),
      height: 1446.25 / (DEFAULT_SQUARE_WIDTH / size),
    }),
  },

  square09: {
    imageSize: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      width: 1080 / (DEFAULT_SQUARE_WIDTH / size),
      height: 1350 / (DEFAULT_SQUARE_WIDTH / size),
    }),
  },

  square10: {
    imageSize: ({ size = DEFAULT_SQUARE_WIDTH }) => ({
      width: 1080 / (DEFAULT_SQUARE_WIDTH / size),
      height: 1350 / (DEFAULT_SQUARE_WIDTH / size),
    }),
  },
};

const squareLogoSize = ({ size = DEFAULT_SQUARE_WIDTH }) => ({
  width: 120 / (DEFAULT_SQUARE_WIDTH / size),
  height: 120 / (DEFAULT_SQUARE_WIDTH / size),
  css: css`
    font-size: ${`calc(28px / ${DEFAULT_SQUARE_WIDTH / size})`};
    line-height: 100%;
    border-radius: ${`calc(11.83px / ${DEFAULT_SQUARE_WIDTH / size})`};
  `,
});

const squareLabelsSize = ({ size = DEFAULT_SQUARE_WIDTH }) => ({
  width: 418.12 / (DEFAULT_SQUARE_WIDTH / size),
  primary: css`
    font-size: ${`calc(64px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
    /* line-height: ${`calc(55.63px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`}; */
    line-height: 100%;
    margin-top: ${`calc(11.76px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
    margin-bottom: ${`calc(23.53px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
  `,
  secondary: css`
    font-size: ${`calc(40px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
    line-height: ${`calc(60px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
    margin-bottom: 0px;
  `,
  call: css`
    font-size: ${`calc(28px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
    line-height: ${`calc(14.67px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
    border-radius: ${`calc(7.76px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
    width: ${`calc(418.12px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
    height: ${`calc(58px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
  `,
});

export function pickSquareDefaultSizes({ shape, size }) {
  switch (shape) {
    case 1:
    default:
      return {
        imageSize: squareSizes.square01.imageSize({ size }),
        logoSize: squareLogoSize({ size }),
        labelsSize: squareLabelsSize({ size }),
      };
    case 2:
      return {
        imageSize: squareSizes.square02.imageSize({ size }),
        logoSize: squareLogoSize({ size }),
        labelsSize: squareLabelsSize({ size }),
      };
    case 3:
      return {
        imageSize: squareSizes.square03.imageSize({ size }),
        logoSize: squareLogoSize({ size }),
        labelsSize: squareLabelsSize({ size }),
      };
    case 4:
      return {
        imageSize: squareSizes.square04.imageSize({ size }),
        logoSize: squareLogoSize({ size }),
        labelsSize: squareLabelsSize({ size }),
      };
    case 5:
      return {
        imageSize: squareSizes.square05.imageSize({ size }),
        logoSize: squareLogoSize({ size }),
        labelsSize: squareLabelsSize({ size }),
      };
    case 6:
      return {
        imageSize: squareSizes.square06.imageSize({ size }),
        logoSize: squareLogoSize({ size }),
        labelsSize: squareLabelsSize({ size }),
      };
    case 7:
      return {
        imageSize: squareSizes.square07.imageSize({ size }),
        logoSize: squareLogoSize({ size }),
        labelsSize: squareLabelsSize({ size }),
      };
    case 8:
      return {
        imageSize: squareSizes.square08.imageSize({ size }),
        logoSize: squareLogoSize({ size }),
        labelsSize: squareLabelsSize({ size }),
      };
    case 9:
      return {
        imageSize: squareSizes.square09.imageSize({ size }),
        logoSize: squareLogoSize({ size }),
        labelsSize: squareLabelsSize({ size }),
      };
    case 10:
      return {
        imageSize: squareSizes.square10.imageSize({ size }),
        logoSize: squareLogoSize({ size }),
        labelsSize: squareLabelsSize({ size }),
      };
  }
}

// VERTICAL RECTANGLE

const verticalRectanglePositions = {
  verticalRectangle01: {
    imagePosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: -181 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 539 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 872.992 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 35.368 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 79 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 178 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
  },
  verticalRectangle02: {
    imagePosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 296 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 684 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 872.992 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 35.368 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 79 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 166 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
  },
  verticalRectangle03: {
    imagePosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 110 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 592 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 872.992 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 35.368 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 52 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 199 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
  },
  verticalRectangle04: {
    imagePosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 130 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: -158 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 872.992 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 1713.96 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 52 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 1138 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
  },
  verticalRectangle05: {
    imagePosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 272 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 599 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 35.368 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 35.368 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 48 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 237 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
  },
  verticalRectangle06: {
    imagePosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: -156 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: -71 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 35.368 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 1713.96 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 442 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 1773 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
  },
  verticalRectangle07: {
    imagePosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 49 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 115 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 35.368 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 35.368 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 65 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 291 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
  },
  verticalRectangle08: {
    imagePosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 96 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 284 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 35.368 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 35.368 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 65 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 230 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
  },
  verticalRectangle09: {
    imagePosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: -220 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: -58 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 24 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 378 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 59 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 782 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
  },
  verticalRectangle10: {
    imagePosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: -286 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: -31 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 35.368 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 35.368 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      x: 59 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      y: 667 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
  },
};

export function pickVerticalRectangleDefaultPositions({ shape, size }) {
  switch (shape) {
    case 1:
    default:
      return {
        imagePosition:
          verticalRectanglePositions.verticalRectangle01.imagePosition({
            size,
          }),
        logoPosition:
          verticalRectanglePositions.verticalRectangle01.logoPosition({ size }),
        labelsPosition:
          verticalRectanglePositions.verticalRectangle01.labelsPosition({
            size,
          }),
      };
    case 2:
      return {
        imagePosition:
          verticalRectanglePositions.verticalRectangle02.imagePosition({
            size,
          }),
        logoPosition:
          verticalRectanglePositions.verticalRectangle02.logoPosition({ size }),
        labelsPosition:
          verticalRectanglePositions.verticalRectangle02.labelsPosition({
            size,
          }),
      };
    case 3:
      return {
        imagePosition:
          verticalRectanglePositions.verticalRectangle03.imagePosition({
            size,
          }),
        logoPosition:
          verticalRectanglePositions.verticalRectangle03.logoPosition({ size }),
        labelsPosition:
          verticalRectanglePositions.verticalRectangle03.labelsPosition({
            size,
          }),
      };
    case 4:
      return {
        imagePosition:
          verticalRectanglePositions.verticalRectangle04.imagePosition({
            size,
          }),
        logoPosition:
          verticalRectanglePositions.verticalRectangle04.logoPosition({ size }),
        labelsPosition:
          verticalRectanglePositions.verticalRectangle04.labelsPosition({
            size,
          }),
      };
    case 5:
      return {
        imagePosition:
          verticalRectanglePositions.verticalRectangle05.imagePosition({
            size,
          }),
        logoPosition:
          verticalRectanglePositions.verticalRectangle05.logoPosition({ size }),
        labelsPosition:
          verticalRectanglePositions.verticalRectangle05.labelsPosition({
            size,
          }),
      };
    case 6:
      return {
        imagePosition:
          verticalRectanglePositions.verticalRectangle06.imagePosition({
            size,
          }),
        logoPosition:
          verticalRectanglePositions.verticalRectangle06.logoPosition({ size }),
        labelsPosition:
          verticalRectanglePositions.verticalRectangle06.labelsPosition({
            size,
          }),
      };
    case 7:
      return {
        imagePosition:
          verticalRectanglePositions.verticalRectangle07.imagePosition({
            size,
          }),
        logoPosition:
          verticalRectanglePositions.verticalRectangle07.logoPosition({ size }),
        labelsPosition:
          verticalRectanglePositions.verticalRectangle07.labelsPosition({
            size,
          }),
      };
    case 8:
      return {
        imagePosition:
          verticalRectanglePositions.verticalRectangle08.imagePosition({
            size,
          }),
        logoPosition:
          verticalRectanglePositions.verticalRectangle08.logoPosition({ size }),
        labelsPosition:
          verticalRectanglePositions.verticalRectangle08.labelsPosition({
            size,
          }),
      };
    case 9:
      return {
        imagePosition:
          verticalRectanglePositions.verticalRectangle09.imagePosition({
            size,
          }),
        logoPosition:
          verticalRectanglePositions.verticalRectangle09.logoPosition({ size }),
        labelsPosition:
          verticalRectanglePositions.verticalRectangle09.labelsPosition({
            size,
          }),
      };
    case 10:
      return {
        imagePosition:
          verticalRectanglePositions.verticalRectangle10.imagePosition({
            size,
          }),
        logoPosition:
          verticalRectanglePositions.verticalRectangle10.logoPosition({ size }),
        labelsPosition:
          verticalRectanglePositions.verticalRectangle10.labelsPosition({
            size,
          }),
      };
  }
}

const verticalRectangleSizes = {
  verticalRectangle01: {
    imageSize: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      width: 1380 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      height: 1932 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
  },
  verticalRectangle02: {
    imageSize: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      width: 1289 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      height: 1805 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
  },
  verticalRectangle03: {
    imageSize: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      width: 1395 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      height: 1953 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
  },
  verticalRectangle04: {
    imageSize: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      width: 1317 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      height: 1844 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
  },
  verticalRectangle05: {
    imageSize: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      width: 1232 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      height: 1725 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
  },
  verticalRectangle06: {
    imageSize: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      width: 1600 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      height: 2240 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
  },
  verticalRectangle07: {
    imageSize: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      width: 1781 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      height: 2493 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
  },
  verticalRectangle08: {
    imageSize: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      width: 1651 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      height: 2311 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
  },
  verticalRectangle09: {
    imageSize: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      width: 2035 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      height: 2849 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
  },
  verticalRectangle10: {
    imageSize: ({ size = DEFAULT_VERTICAL_RECTANGLE_WIDTH }) => ({
      width: 1982 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
      height: 2775 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    }),
  },
};

function verticalRectangleLogoSize({
  size = DEFAULT_VERTICAL_RECTANGLE_WIDTH,
}) {
  return {
    width: 170.67 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    height: 170.67 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    css: css`
      font-size: ${`calc(39.82px / ${DEFAULT_VERTICAL_RECTANGLE_WIDTH / size})`};
      line-height: 100%;
      border-radius: ${`calc(16.82px / ${
        DEFAULT_VERTICAL_RECTANGLE_WIDTH / size
      })`};
    `,
  };
}

function verticalRectangleLabelsSize({
  size = DEFAULT_VERTICAL_RECTANGLE_WIDTH,
}) {
  return {
    width: 585.99 / (DEFAULT_VERTICAL_RECTANGLE_WIDTH / size),
    primary: css`
      font-size: ${`calc(88px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
      /* line-height: ${`calc(55.63px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`}; */
      line-height: 100%;
      margin-top: ${`calc(16px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
      margin-bottom: ${`calc(33px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
    `,
    secondary: css`
      font-size: ${`calc(48px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
      line-height: 100%;
      margin-bottom: 0px;
    `,
    call: css`
      font-size: ${`calc(39.24px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
      line-height: 100%;
      border-radius: ${`calc(10.88px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
      width: ${`calc(585.98974609375px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
      height: ${`calc(81.42387390136719px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
      margin-top: ${`calc(-16.03px / (${DEFAULT_VERTICAL_RECTANGLE_WIDTH} / ${size}))`};
    `,
  };
}

export function pickVerticalRectangleDefaultSizes({ shape, size }) {
  switch (shape) {
    case 1:
    default:
      return {
        imageSize: verticalRectangleSizes.verticalRectangle01.imageSize({
          size,
        }),
        logoSize: verticalRectangleLogoSize({ size }),
        labelsSize: verticalRectangleLabelsSize({ size }),
      };
    case 2:
      return {
        imageSize: verticalRectangleSizes.verticalRectangle02.imageSize({
          size,
        }),
        logoSize: verticalRectangleLogoSize({ size }),
        labelsSize: verticalRectangleLabelsSize({ size }),
      };
    case 3:
      return {
        imageSize: verticalRectangleSizes.verticalRectangle03.imageSize({
          size,
        }),
        logoSize: verticalRectangleLogoSize({ size }),
        labelsSize: verticalRectangleLabelsSize({ size }),
      };
    case 4:
      return {
        imageSize: verticalRectangleSizes.verticalRectangle04.imageSize({
          size,
        }),
        logoSize: verticalRectangleLogoSize({ size }),
        labelsSize: verticalRectangleLabelsSize({ size }),
      };
    case 5:
      return {
        imageSize: verticalRectangleSizes.verticalRectangle05.imageSize({
          size,
        }),
        logoSize: verticalRectangleLogoSize({ size }),
        labelsSize: verticalRectangleLabelsSize({ size }),
      };
    case 6:
      return {
        imageSize: verticalRectangleSizes.verticalRectangle06.imageSize({
          size,
        }),
        logoSize: verticalRectangleLogoSize({ size }),
        labelsSize: verticalRectangleLabelsSize({ size }),
      };
    case 7:
      return {
        imageSize: verticalRectangleSizes.verticalRectangle07.imageSize({
          size,
        }),
        logoSize: verticalRectangleLogoSize({ size }),
        labelsSize: verticalRectangleLabelsSize({ size }),
      };
    case 8:
      return {
        imageSize: verticalRectangleSizes.verticalRectangle08.imageSize({
          size,
        }),
        logoSize: verticalRectangleLogoSize({ size }),
        labelsSize: verticalRectangleLabelsSize({ size }),
      };
    case 9:
      return {
        imageSize: verticalRectangleSizes.verticalRectangle09.imageSize({
          size,
        }),
        logoSize: verticalRectangleLogoSize({ size }),
        labelsSize: verticalRectangleLabelsSize({ size }),
      };
    case 10:
      return {
        imageSize: verticalRectangleSizes.verticalRectangle10.imageSize({
          size,
        }),
        logoSize: verticalRectangleLogoSize({ size }),
        labelsSize: verticalRectangleLabelsSize({ size }),
      };
  }
}

// HORIZONTAL RECTANGLE

const horizontalRectanglePositions = {
  horizontalRectangle01: {
    imagePosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: -149 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: 5 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 1094 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: 24 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 671 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: 196 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
  },
  horizontalRectangle02: {
    imagePosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 600 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: -28 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 24 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: 24 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 80 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: 196 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
  },
  horizontalRectangle03: {
    imagePosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 600 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: 65 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 24 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: 24 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 80 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: 196 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
  },
  horizontalRectangle04: {
    imagePosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 440 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: -202 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 1094 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: 524 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 80 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: 312 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
  },
  horizontalRectangle05: {
    imagePosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 564 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: 84 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 24 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: 24 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 80 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: 196 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
  },
  horizontalRectangle06: {
    imagePosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: -30 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: -77 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 1094 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: 24 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 754 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: 323 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
  },
  horizontalRectangle07: {
    imagePosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 580 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: -31 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 24 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: 24 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 80 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: 196 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
  },
  horizontalRectangle08: {
    imagePosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 393 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: -99 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 24 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: 24 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 80 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: 196 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
  },
  horizontalRectangle09: {
    imagePosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 474 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: -65 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 24 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: 24 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 80 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: 196 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
  },
  horizontalRectangle10: {
    imagePosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 474 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: -65 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
    logoPosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 24 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: 24 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
    labelsPosition: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      x: 80 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      y: 196 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
  },
};

export function pickHorizontalRectangleDefaultPositions({ shape, size }) {
  switch (shape) {
    case 1:
    default:
      return {
        imagePosition:
          horizontalRectanglePositions.horizontalRectangle01.imagePosition({
            size,
          }),
        logoPosition:
          horizontalRectanglePositions.horizontalRectangle01.logoPosition({
            size,
          }),
        labelsPosition:
          horizontalRectanglePositions.horizontalRectangle01.labelsPosition({
            size,
          }),
      };
    case 2:
      return {
        imagePosition:
          horizontalRectanglePositions.horizontalRectangle02.imagePosition({
            size,
          }),
        logoPosition:
          horizontalRectanglePositions.horizontalRectangle02.logoPosition({
            size,
          }),
        labelsPosition:
          horizontalRectanglePositions.horizontalRectangle02.labelsPosition({
            size,
          }),
      };
    case 3:
      return {
        imagePosition:
          horizontalRectanglePositions.horizontalRectangle03.imagePosition({
            size,
          }),
        logoPosition:
          horizontalRectanglePositions.horizontalRectangle03.logoPosition({
            size,
          }),
        labelsPosition:
          horizontalRectanglePositions.horizontalRectangle03.labelsPosition({
            size,
          }),
      };
    case 4:
      return {
        imagePosition:
          horizontalRectanglePositions.horizontalRectangle04.imagePosition({
            size,
          }),
        logoPosition:
          horizontalRectanglePositions.horizontalRectangle04.logoPosition({
            size,
          }),
        labelsPosition:
          horizontalRectanglePositions.horizontalRectangle04.labelsPosition({
            size,
          }),
      };
    case 5:
      return {
        imagePosition:
          horizontalRectanglePositions.horizontalRectangle05.imagePosition({
            size,
          }),
        logoPosition:
          horizontalRectanglePositions.horizontalRectangle05.logoPosition({
            size,
          }),
        labelsPosition:
          horizontalRectanglePositions.horizontalRectangle05.labelsPosition({
            size,
          }),
      };
    case 6:
      return {
        imagePosition:
          horizontalRectanglePositions.horizontalRectangle06.imagePosition({
            size,
          }),
        logoPosition:
          horizontalRectanglePositions.horizontalRectangle06.logoPosition({
            size,
          }),
        labelsPosition:
          horizontalRectanglePositions.horizontalRectangle06.labelsPosition({
            size,
          }),
      };
    case 7:
      return {
        imagePosition:
          horizontalRectanglePositions.horizontalRectangle07.imagePosition({
            size,
          }),
        logoPosition:
          horizontalRectanglePositions.horizontalRectangle07.logoPosition({
            size,
          }),
        labelsPosition:
          horizontalRectanglePositions.horizontalRectangle07.labelsPosition({
            size,
          }),
      };
    case 8:
      return {
        imagePosition:
          horizontalRectanglePositions.horizontalRectangle08.imagePosition({
            size,
          }),
        logoPosition:
          horizontalRectanglePositions.horizontalRectangle08.logoPosition({
            size,
          }),
        labelsPosition:
          horizontalRectanglePositions.horizontalRectangle08.labelsPosition({
            size,
          }),
      };
    case 9:
      return {
        imagePosition:
          horizontalRectanglePositions.horizontalRectangle09.imagePosition({
            size,
          }),
        logoPosition:
          horizontalRectanglePositions.horizontalRectangle09.logoPosition({
            size,
          }),
        labelsPosition:
          horizontalRectanglePositions.horizontalRectangle09.labelsPosition({
            size,
          }),
      };
    case 10:
      return {
        imagePosition:
          horizontalRectanglePositions.horizontalRectangle10.imagePosition({
            size,
          }),
        logoPosition:
          horizontalRectanglePositions.horizontalRectangle10.logoPosition({
            size,
          }),
        labelsPosition:
          horizontalRectanglePositions.horizontalRectangle10.labelsPosition({
            size,
          }),
      };
  }
}

const horizontalRectangleSizes = {
  horizontalRectangle01: {
    imageSize: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      width: 741 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      height: 741 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
  },
  horizontalRectangle02: {
    imageSize: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      width: 683 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      height: 683 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
  },
  horizontalRectangle03: {
    imageSize: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      width: 600 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      height: 600 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
  },
  horizontalRectangle04: {
    imageSize: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      width: 800 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      height: 800 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
  },
  horizontalRectangle05: {
    imageSize: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      width: 636 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      height: 636 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
  },
  horizontalRectangle06: {
    imageSize: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      width: 786 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      height: 786 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
  },
  horizontalRectangle07: {
    imageSize: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      width: 730 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      height: 730 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
  },
  horizontalRectangle08: {
    imageSize: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      width: 800 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      height: 800 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
  },
  horizontalRectangle09: {
    imageSize: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      width: 757 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      height: 757 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
  },
  horizontalRectangle10: {
    imageSize: ({ size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH }) => ({
      width: 757 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
      height: 757 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    }),
  },
};

function horizontalRectangleLogoSize({
  size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH,
}) {
  return {
    width: 75.84 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    height: 75.84 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    css: css`
      font-size: ${`calc(18.96px / ${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size})`};
      line-height: 100%;
      border-radius: ${`calc(7.66px / ${
        DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size
      })`};
    `,
  };
}

function horizontalRectangleLabelsSize({
  size = DEFAULT_HORIZONTAL_RECTANGLE_WIDTH,
}) {
  return {
    width: 360 / (DEFAULT_HORIZONTAL_RECTANGLE_WIDTH / size),
    primary: css`
      font-size: ${`calc(56px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
      /* line-height: ${`calc(55.63px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`}; */
      line-height: 100%;
      margin-top: ${`calc(16px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
      margin-bottom: ${`calc(24px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
    `,
    secondary: css`
      font-size: ${`calc(34.44px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
      line-height: 100%;
      margin-bottom: 0px;
    `,
    call: css`
      font-size: ${`calc(24.11px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
      line-height: 100%;
      border-radius: ${`calc(6.68px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
      width: ${`calc(360px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
      height: ${`calc(49.78px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
      margin-top: ${`calc(-10px / (${DEFAULT_HORIZONTAL_RECTANGLE_WIDTH} / ${size}))`};
    `,
  };
}

export function pickHorizontalRectangleDefaultSizes({ shape, size }) {
  switch (shape) {
    case 1:
    default:
      return {
        imageSize: horizontalRectangleSizes.horizontalRectangle01.imageSize({
          size,
        }),
        logoSize: horizontalRectangleLogoSize({ size }),
        labelsSize: horizontalRectangleLabelsSize({ size }),
      };
    case 2:
      return {
        imageSize: horizontalRectangleSizes.horizontalRectangle02.imageSize({
          size,
        }),
        logoSize: horizontalRectangleLogoSize({ size }),
        labelsSize: horizontalRectangleLabelsSize({ size }),
      };
    case 3:
      return {
        imageSize: horizontalRectangleSizes.horizontalRectangle03.imageSize({
          size,
        }),
        logoSize: horizontalRectangleLogoSize({ size }),
        labelsSize: horizontalRectangleLabelsSize({ size }),
      };
    case 4:
      return {
        imageSize: horizontalRectangleSizes.horizontalRectangle04.imageSize({
          size,
        }),
        logoSize: horizontalRectangleLogoSize({ size }),
        labelsSize: horizontalRectangleLabelsSize({ size }),
      };
    case 5:
      return {
        imageSize: horizontalRectangleSizes.horizontalRectangle05.imageSize({
          size,
        }),
        logoSize: horizontalRectangleLogoSize({ size }),
        labelsSize: horizontalRectangleLabelsSize({ size }),
      };
    case 6:
      return {
        imageSize: horizontalRectangleSizes.horizontalRectangle06.imageSize({
          size,
        }),
        logoSize: horizontalRectangleLogoSize({ size }),
        labelsSize: horizontalRectangleLabelsSize({ size }),
      };
    case 7:
      return {
        imageSize: horizontalRectangleSizes.horizontalRectangle07.imageSize({
          size,
        }),
        logoSize: horizontalRectangleLogoSize({ size }),
        labelsSize: horizontalRectangleLabelsSize({ size }),
      };
    case 8:
      return {
        imageSize: horizontalRectangleSizes.horizontalRectangle08.imageSize({
          size,
        }),
        logoSize: horizontalRectangleLogoSize({ size }),
        labelsSize: horizontalRectangleLabelsSize({ size }),
      };
    case 9:
      return {
        imageSize: horizontalRectangleSizes.horizontalRectangle09.imageSize({
          size,
        }),
        logoSize: horizontalRectangleLogoSize({ size }),
        labelsSize: horizontalRectangleLabelsSize({ size }),
      };
    case 10:
      return {
        imageSize: horizontalRectangleSizes.horizontalRectangle10.imageSize({
          size,
        }),
        logoSize: horizontalRectangleLogoSize({ size }),
        labelsSize: horizontalRectangleLabelsSize({ size }),
      };
  }
}
